/**
 * 注册类型
 */
export const PlatformTypeEnum = Object.freeze(
  {
    /** 微信小程序 */
    WECHAT_MINI: 1,
    /** 抖音小程序 */
    DOUYIN_MINI: 2,
    /** Pc官网 */
    PC_OFFICE: 3,
    /** 移动官网 */
    MOBILE_OFFICE: 4,
    /** 安卓应用 */
    ANDROID_APP: 5,
    /** ios应用 */
    IOS_APP: 6,
  }
)

/**
 * 注册类型的选项
 * @readonly
 * @type {Readonly<[{label: string, type: string, value: number}]>}
 */
export const PlatformTypeOptions =  Object.freeze([
  {
    value: PlatformTypeEnum.WECHAT_MINI,
    label: "微信小程序",
    type: "info"
  },
  {
    value: PlatformTypeEnum.DOUYIN_MINI,
    label: "抖音小程序",
    type: "info"
  },
  {
    value: PlatformTypeEnum.PC_OFFICE,
    label: "Pc官网",
    type: "info"
  },
  {
    value: PlatformTypeEnum.MOBILE_OFFICE,
    label: "移动官网",
    type: "info"
  },
  {
    value: PlatformTypeEnum.ANDROID_APP,
    label: "安卓应用",
    type: "info"
  },
  {
    value: PlatformTypeEnum.IOS_APP,
    label: "ios应用",
    type: "info"
  }
])



// WEBPACK FOOTER //
// ./src/enums/userEnum.js